module.exports = __webpack_public_path__ + "img/cle2.fab69127.png";